import { FormArray, ValidatorFn } from '@angular/forms';
import { FileFormGroup } from './file-form-group';

export class FileFormArray extends FormArray {

    public get fileFormGroups(): FileFormGroup[] {
        return this.controls as FileFormGroup[];
    }

    public get hasArrayLengthError(): boolean {
        return this.hasError(FileFormArray.maxArrayLengthError);
    }
    private static readonly requireFilesError = 'requireFiles';
    private static readonly maxArrayLengthError = 'arrayLength';
    private customValidators: ValidatorFn[];

    constructor(isRequired = true) {
        super([]);
        this.customValidators = [FileFormArray.baseFilesValidator()];

        if (isRequired) {
            this.customValidators.push(FileFormArray.requireFilesValidator());
        }

        this.setCustomValidators();
    }

    public getByIndex(fileIndex: number): FileFormGroup {
        return this.at(fileIndex) as FileFormGroup;
    }

    public setCustomValidators(validators: ValidatorFn[] = []) {
        this.customValidators = this.customValidators.concat(validators);
        this.setValidators(this.customValidators);
    }

    public static maxArrayLengthValidator(maxArrayLength: number): ValidatorFn {
        return (fileControls: FileFormArray) => {
            return fileControls.length > maxArrayLength
                ? { [this.maxArrayLengthError]: true }
                : null;
        };
    }     

    private static baseFilesValidator(): ValidatorFn {
        return (fileControls: FileFormArray) => {
            for (let fileControl of fileControls.fileFormGroups) {
                fileControl.languageControl.updateValueAndValidity({ onlySelf: true });
                fileControl.fileNameControl.updateValueAndValidity({ onlySelf: true });
                fileControl.updateValueAndValidity({ onlySelf: true });
            }
            return null;
        };
    }  

    private static requireFilesValidator(): ValidatorFn {
        return (fileControls: FileFormArray) => {
            return !fileControls.length
                ? { [this.requireFilesError]: true }
                : null;
        };
    }  
}